































import {Component, Prop, Vue} from "vue-property-decorator";
import Workspace from "@/dto/auth/Workspace";
import {namespace} from "vuex-class";

const Auth = namespace("Auth");
const AppModule = namespace("App");

@Component
export default class DeleteConfirmationModal extends Vue {

    @AppModule.Action
    private startLoading!: () => void

    @AppModule.Action
    private stopLoading!: () => void

    private successful = false;

    private message = "";

    @Prop()
    public onDelete!: () => void

    closeModal() {
        this.$modal.hideAll()
    }

    deleteDocument() {
        if (this.onDelete) {
            this.onDelete();
        }
        this.closeModal();
    }
}
